import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription, of, defer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { NotificationService } from 'src/app/modules/general/services/notification.service';
import { PartnerRegistrationService } from 'src/app/modules/partner-registration/services/partner-registration.service';

@Component({
  selector: 'app-partner-confirmation-text',
  templateUrl: './partner-confirmation-text.component.html',
  styleUrls: ['./partner-confirmation-text.component.css']
})
export class PartnerConfirmationTextComponent implements OnInit, OnDestroy {

  confirmationText: string;
  private _confirmationTextSubscription: Subscription;
  private _langChange: Subscription;

  constructor(
    private partnerRegistrationService: PartnerRegistrationService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
    this._confirmationTextSubscription = this._reloadConfirmationText().subscribe();
    this._langChange = this.translateService.onLangChange.pipe(
      switchMap(_ => this._reloadConfirmationText()),
    ).subscribe();
  }

  ngOnDestroy(): void {
    this._unsubscribeConfirmationTextSubscription();
    this._unsubscribeLangChangeSubscription();
    this.notificationService.hide(PartnerConfirmationTextComponent.name);
  }

  private _reloadConfirmationText(): Observable<boolean> {
    return defer(() => {
      this.notificationService.hide(PartnerConfirmationTextComponent.name);
      return this.partnerRegistrationService.getConfirmationText()
        .pipe(
          map(result => {
            this.confirmationText = result;
            return !!result;
          }),
          catchError((error) => {
            this.notificationService.show(PartnerConfirmationTextComponent.name, error.message);
            return of(false);
          }),
        );
    })
  }

  private _unsubscribeConfirmationTextSubscription(): void {
    if (this._confirmationTextSubscription) {
      this._confirmationTextSubscription.unsubscribe();
      this._confirmationTextSubscription = null;
    }
  }

  private _unsubscribeLangChangeSubscription(): void {
    if (this._langChange) {
      this._langChange.unsubscribe();
      this._langChange = null;
    }
  }
}
